import { useCallback } from 'react';

const HOME_PATH = '/';

const CLOSE_GRACE_PERIOD_MS = 150;

export const requestCloseWindow = (): void => {
	if (typeof window === 'undefined') return;

	window.close();

	window.setTimeout(() => {
		if (window.closed) return;
		window.location.assign(HOME_PATH);
	}, CLOSE_GRACE_PERIOD_MS);
};

export interface UseCloseWindowResult {
	requestClose: () => void;
}

export const useCloseWindow = (): UseCloseWindowResult => {
	const requestClose = useCallback(() => {
		requestCloseWindow();
	}, []);

	return { requestClose };
};
